import React, { useState, useEffect, Fragment } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
// import PropTypes from 'prop-types';
import { SIMMONS_DATA } from '../../../constants';
import { RLD_RECTYPE_Q } from '../RldConstant';
import closedIcon from '../../../images/RldTool/arrow_closed.svg';
import openedIcon from '../../../images/RldTool/arrow_opened.svg';
import {
  RldToolClosedIcon,
  RldToolNode,
  RldToolNodeLabel,
  RldToolOpenedIcon,
} from './styledComponents';
import { findTreeNode } from '../../common/DynamicTree/DynamicTreeUtils';
import { getDictionaryTreeLoad } from '../../../actions/rldToolActions';


const RldToolDictionaryTree = ({
  handleSelection,
  items: dictionaryTree,
  itemsOnOtherSide,
  selectedItems,
  isSelectedBox,
  selectedAccount,
  selectedStudy,
  isExpandable,
}) => {
  const [categoryExpanded, setCategoryExpanded] = useState({
    simmonsNode: {},
    qtsNode: {},
  });
  const [nodeClicked, setNodeClicked] = useState(false);
  // To Keep track whether the nodes clicked at the least once when dictionaryTree present
  const [nodeClickedAtLeastOnce, setNodeClickedAtLeastOnce] = useState(false);
  const [currentCategory, setCurrentCategory] = useState({});
  const { uid } = useSelector(state => ({
    uid: state.login.loginResponse.data.uid,
  }));

  const filter = SIMMONS_DATA;
  const dispatch = useDispatch();

  const handleNodeClick = category => {
    setCurrentCategory(category);
    setNodeClicked(true);
    setNodeClickedAtLeastOnce(true);
    setCategoryExpanded(prevCategoryExpanded => {
      return {
        ...prevCategoryExpanded,
        simmonsNode: {
          ...prevCategoryExpanded.simmonsNode,
          ...{
            [category.node]: !prevCategoryExpanded.simmonsNode[category.node],
          },
        },
      };
    });
  };

  //  To reset nodeClickedAtLeastOnce false at any time dictionaryTree is empty and
  // nodes been selected at least once, to reset categoryExpanded to initial state
  // to manage expanded categories list
  if (
    nodeClickedAtLeastOnce &&
    (!dictionaryTree || dictionaryTree.length === 0)
  ) {
    setNodeClickedAtLeastOnce(false);
    setCategoryExpanded({
      simmonsNode: {},
      qtsNode: {},
    });
  }

  // get sub trees whenever, node colapsble button clicked
  // Get tree nodes if only category is in collapsed state
  if (
    nodeClicked &&
    !_.isEmpty(currentCategory) &&
    categoryExpanded.simmonsNode[currentCategory.node]
  ) {
    // Get sub-category if only there are selected account, selected study, and
    // No children (sub-category) present in for the current node, if there is use the existing.
    if (
      !_.isEmpty(selectedAccount) &&
      selectedStudy &&
      !currentCategory.children
    ) {
      dispatch(
        getDictionaryTreeLoad(
          uid,
          selectedAccount.accountId,
          selectedStudy,
          currentCategory.node,
          filter
        )
      );
    }
    setNodeClicked(false);
    setCurrentCategory({});
  }

  const getChildren = (category, level) => {
    if (
      category.children &&
      category.children.length &&
      category.rectype !== RLD_RECTYPE_Q
    ) {
      return renderCategories(category.children, ++level);
    }
    return false;
  };

  const handleItemSelection = (event, category, nodeIndex) => {
    event.preventDefault();
    const selectedElementId = category.node;

    setCurrentCategory(category);

    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }

    if (event.shiftKey) {
      shiftKey = true;
    }
    handleSelection(selectedElementId, clearExisting, shiftKey, nodeIndex);
  };

  const renderCategories = (data, level) => {
    return data.map((category, nodeIndex) => {
      const selectedNode = findTreeNode(selectedItems, category.node);

      // PLAT-12276 - Sub-categories are not allowed to expanded
      // if the parent category is in selected list
      let isSubCategoryExpandable = true;
      if (itemsOnOtherSide && itemsOnOtherSide.length !== 0) {
        const itemOnOtherSideList = findTreeNode(
          itemsOnOtherSide,
          category.node
        );

        if (category.node === itemOnOtherSideList.node) {
          isSubCategoryExpandable = false;
        }
      }


      return (
        <Fragment>
          <RldToolNode
            level={level}
            onMouseDown={event => {
              handleItemSelection(event, category, nodeIndex);
            }}
            id={category.node}
            key={category.uniqueId}
            data-uniqueId={category.uniqueId}
            isSelected={category.node === selectedNode.node}
            isMoved={!isSubCategoryExpandable}
            nodeIndex={nodeIndex}
          >
            {isExpandable &&
              isSubCategoryExpandable &&
              category.rectype !== RLD_RECTYPE_Q &&
              !categoryExpanded.simmonsNode[category.node] && (
                <RldToolClosedIcon
                  src={closedIcon}
                  alt="Closed Icon"
                  onClick={() => handleNodeClick(category)}
                />
              )}
            {isExpandable &&
              isSubCategoryExpandable &&
              category.rectype !== RLD_RECTYPE_Q &&
              categoryExpanded.simmonsNode[category.node] && (
                <RldToolOpenedIcon
                  src={openedIcon}
                  alt="Opened Icon"
                  onClick={() => handleNodeClick(category)}
                />
              )}
            <RldToolNodeLabel
              font={categoryExpanded.simmonsNode[category.node]}
              title={category.shortText}
            >
              {category.shortText}
            </RldToolNodeLabel>
          </RldToolNode>

          {isExpandable &&
          isSubCategoryExpandable &&
          categoryExpanded.simmonsNode[category.node]
            ? getChildren(category, level)
            : false}
        </Fragment>
      );
    });
  };

  return (
    <React.Fragment>
      <div className="multi-select-list">
        {(!dictionaryTree || dictionaryTree.length === 0) && (
          <div>No results found</div>
        )}
        {dictionaryTree && dictionaryTree.length !== 0 && (
          <div>{renderCategories(dictionaryTree, 1)}</div>
        )}
      </div>
    </React.Fragment>
  );
};;;

export default RldToolDictionaryTree;
